import React from "react";
import KarwanPage from "pages/Karwan";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import NotFound from "pages/NotFound";
import PrivacyPolicy from "pages/PrivacyPolicy";

const ProjectRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<KarwanPage />} />
        <Route path="*" element={<NotFound />} />
        <Route path="/karwan" element={<KarwanPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </Router>
  );
};

export default ProjectRoutes;
